export default function ErrorPage() {
  return (
    <div style={{ width: "50%", margin: "auto", marginTop: 200 }}>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
    </div>
  );
}
